import LocationSpaceImages from "./LocationSpaceImages";
import { ILocationSpaceImage, ILocationSpaceImages } from "./ILocationSpaceImages";

export type { ILocationSpaceImage, ILocationSpaceImages };
export default LocationSpaceImages;
